import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
export function Benefits() {
  const benefits = ['Vas a dejar de postergar', 'Vas a tener claridad diaria', 'Vas a cumplir lo que te proponés', 'Vas a sentir control sobre tu vida'];
  return <section className="w-full bg-white py-20 md:py-32 px-4" data-id="element-14">
      <div className="max-w-4xl mx-auto" data-id="element-15">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center" data-id="element-16">
          <h2 className="text-4xl md:text-6xl font-black mb-16" data-id="element-17">
            Qué va a cambiar después de aplicarlo
          </h2>

          <div className="space-y-6 text-left max-w-2xl mx-auto" data-id="element-18">
            {benefits.map((benefit, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1,
            duration: 0.5
          }} className="flex items-start gap-4 bg-green-50 p-6 rounded-xl" data-id="element-19">
                <CheckIcon className="w-8 h-8 text-green-500 flex-shrink-0 mt-1" data-id="element-20" />
                <p className="text-xl md:text-2xl font-semibold" data-id="element-21">{benefit}</p>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}